import {Breadcrumbs, Link} from "@mui/material";
import {Link as RouterLink} from "react-router-dom";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import {breadcrumbsSx, CrumbText} from "./styles";

/**
* A thin wrapper around MUI's that:
*     - Accepts a list of { name, routePath? } items.
*     - Uses for navigable crumbs (so middle‑click / new tab works).
*     - Renders the last crumb as plain text with aria-current="page".
*     - Centralizes styling via breadcrumbsSx (theme‑aware).
* */

export type BreadCrumb = { name: string; routePath?: string };

export default function AppBreadcrumbs({breadcrumbList, disabled = false}: {
    breadcrumbList: BreadCrumb[]; disabled?: boolean
}) {
    return (<Breadcrumbs
            data-cy="breadcrumb"
            aria-label="breadcrumbs"
            separator={<KeyboardArrowRightIcon/>}
            sx={(t) => breadcrumbsSx(t)}
        >
            {breadcrumbList.map((b, i) => i < breadcrumbList.length - 1 && b.routePath ? (
                <Link key={b.name} component={RouterLink} to={b.routePath}>{b.name}</Link>) : (
                <CrumbText key={b.name} aria-current="page">{b.name}</CrumbText>))}
        </Breadcrumbs>);
}